import { YStack, YStackProps } from '@my/ui'
import { SolitoImage } from 'solito/image'
import { SolitoImageProps } from 'solito/build/image/image.types'
import avatarDefault from 'app/assets/images/group-avatar-default.png'

type AvatarProps = {
  src?: any
  alt?: string
  rounded?: boolean
  imageProps?: SolitoImageProps
} & YStackProps

export const GroupAvatar = ({
  src,
  alt,
  width = 100,
  height = 100,
  rounded = true,
  imageProps,
  ...props
}: AvatarProps) => {
  return (
    <YStack
      borderRadius={rounded ? 100_000 : '$3'}
      jc="center"
      ai="center"
      w={width}
      h={height}
      overflow="hidden"
      bg="$grey3"
      {...props}
    >
      <SolitoImage contentFit="fill" src={src || avatarDefault} alt={alt || 'Group avatar'} fill />
    </YStack>
  )
}
